import React from "react";
import { useForm } from "react-hook-form";
import useAuthActions from "../../../api/hooks/admin/auth";
import InputText from "../../atoms/input/InputText";
import Header from "../../modules/layout/Header";
import { useNavigate } from "react-router-dom";

const LoginForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const { adminLogin } = useAuthActions();

  const onSubmit = async (data) => {
    const req = { type: 0, id: data.id, pw: data.password };

    const res = await adminLogin(req);
    // if (res.status === 200) navigate(`/admin/home`);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="base-sec-sec">
        <div className="login-welcome">
          <div className="login-logo"></div>
        </div>
        <div className="login-active">
          <div className="login-id">
            <p className="login-title">아이디</p>
            <InputText
              className="login-input"
              refs={{
                ...register("id"),
              }}
            />
          </div>

          <div className="login-password">
            <p className="login-title">비밀번호</p>
            <InputText
              className="login-input"
              type="password"
              refs={{
                ...register("password"),
              }}
            />
          </div>
          <div className="password-remember">
            <label className="check-container">
              <input type="checkbox" />
              <span className="checkmark"></span>
              <span>비밀번호 기억하기</span>
            </label>
          </div>
          <button className="login-act" type="submit">
            로그인
          </button>
        </div>
        <div className="text-align-center"></div>
      </div>
      <div className="base-sec-bottom" />
    </form>
  );
};

const AdminLogin = () => {
  return (
    <div>
      <link rel="stylesheet" type="text/css" href="/css/common.css" />
      <Header />
      <div className="base-sec login-sec">
        <div className="background-color-w">
          <div className="base-sec-top flex">
            <div>
              <p className="title">관리자 페이지</p>
            </div>
            <div>
              <button className="close"></button>
            </div>
          </div>
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
